<template>
  <div class="h-full flex-1 flex flex-row">
    <div class="w-1/2 h-full p-2">
      <slot name="left"></slot>
    </div>
    <div class="w-1/2 h-full p-2 border-l-1 border-black">
      <slot name="right"></slot>
    </div>
  </div>
</template>